// extracted by mini-css-extract-plugin
export default {"root":"PrepMaterialShow_root__lfPXv","title":"PrepMaterialShow_title__bnkLh","materialTitle":"PrepMaterialShow_materialTitle__1KKFH"};